'use strict';

class TimeoutError extends Error {
  constructor() {
    let message = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'Request timed out';
    super(message);
    this.name = 'TimeoutError';
  }

}

exports.TimeoutError = TimeoutError;

class AbortError extends Error {
  constructor() {
    let message = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'The operation was aborted.';
    super(message);
    this.name = 'AbortError';
  }

}

exports.AbortError = AbortError;

class HTTPError extends Error {
  /**
   * @param {Response} response
   */
  constructor(response) {
    super(response.statusText);
    this.name = 'HTTPError';
    this.response = response;
  }

}

exports.HTTPError = HTTPError;